import GCarousel from "./g-carousel";
import { fetchRetailRecommendations } from "./g-utils";

class GoFurther extends GCarousel {
  constructor() {
    super();
    this.observer = null; // Define the IntersectionObserver instance
  }

  async connectedCallback() {
    await super.connectedCallback();
    await this.fetchItems();
  }

  async fetchItems() {
    if (!this.isbn) {
      this.setAttribute("aria-hidden", true);
      return;
    }
 
    const recommendationsJson = await fetchRetailRecommendations({
      type: "go_further",
      products: [
        {
          primaryProductId: this.isbn,
        },
      ],
      pageSize: this.recommendationsCount,
    }) 
    if (!recommendationsJson?.result || recommendationsJson?.result.length === 0) {
      this.setAttribute("aria-hidden", true);
      return;
    } 

    const productIds = recommendationsJson.result.map((opus) => opus.isbn);
    let sectionUrl = `?sections=ajax-go-further-v2-items&product_ids=${productIds}`;
    if(this.dataset.carouselId) {
      sectionUrl += `&carousel_id=${this.dataset.carouselId}`
    }
    if(this.dataset.carouselName) {
      sectionUrl += `&carousel_name=${encodeURI(this.dataset.carouselName)}`
    }
    const sectionResponse = await fetch(window.Shopify.routes.root + sectionUrl);
    const sectionJson = await sectionResponse.json();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sectionJson[Object.keys(sectionJson)[0]];
    const items = tempDiv.querySelector(".js-content");

    if (items && items.childElementCount > 0) {
      this.splideList.innerHTML = items.innerHTML;
      this.setAttribute("aria-hidden", false);
    } else {
      this.setAttribute("aria-hidden", true);
    }

    if(this.splide) {
      this.splide.refresh();
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get isbn() {
    return this.dataset.isbn;
  }

  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }
}

customElements.define("go-further", GoFurther);
